import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const SCOPE_LABEL = {
  tienda: "Tienda",
  envio: "Envío",
  pagos: "Pagos",
  general: "General",
};

export default function FaqsPublic() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api
      .get("/faqs")
      .then((r) => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  const byScope = ["tienda", "envio", "pagos", "general"].reduce((acc, s) => {
    acc[s] = (items || []).filter((f) => f.scope === s);
    return acc;
  }, {});

  return (
    <main
      data-testid="public-faqs"
      className="mx-auto max-w-3xl px-4 sm:px-6 py-10 space-y-8"
    >
      <div>
        <h1 className="text-4xl font-black tracking-tight">Preguntas frecuentes</h1>
        <p className="text-neutral-500 mt-2">
          Encuentra respuestas rápidas sobre MercaGo.
        </p>
      </div>
      {items === null ? (
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-14 rounded-xl bg-neutral-100 animate-pulse" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <p className="text-neutral-500">Aún no hay preguntas publicadas.</p>
      ) : (
        Object.entries(byScope)
          .filter(([, arr]) => arr.length > 0)
          .map(([scope, arr]) => (
            <section key={scope} data-testid={`public-faqs-scope-${scope}`}>
              <h2 className="text-xl font-black mb-3">{SCOPE_LABEL[scope]}</h2>
              <div className="space-y-2">
                {arr.map((f) => (
                  <details
                    key={f.id}
                    data-testid={`public-faq-item-${f.id}`}
                    className="rounded-xl border border-neutral-200 bg-white p-3"
                  >
                    <summary className="cursor-pointer font-semibold">{f.q}</summary>
                    <p className="mt-2 text-sm text-neutral-700 whitespace-pre-wrap">
                      {f.a}
                    </p>
                  </details>
                ))}
              </div>
            </section>
          ))
      )}
    </main>
  );
}
